import { useIntercomRoomParticipantsStatusesStore } from '@/entities/room'

import type { Contact } from '@/shared/types/api'
import { Room } from '@/shared/types/store'
import { GUEST_PREFIX } from '@/shared/utils/constants'
import { contactFromGuest } from '@/shared/utils/contact'
import { fromPServedUser } from '@/shared/utils/uri'

export type RoomSubscriberWithId = { contact: Contact, participantId: string }

export const getParticipantsFromRoom = (room: Room): RoomSubscriberWithId[] => {
  const { getIsParticipantIsActive } = useIntercomRoomParticipantsStatusesStore()

  const guests = [...room.guests ?? []]
    .map(([, guest]) => ({ contact: contactFromGuest(guest), participantId: guest.pServed }))
    .filter(({ participantId }) => getIsParticipantIsActive(room.pServedUser, fromPServedUser(participantId)))

  const subscribers = [...room.subscribers ?? []]
    .filter(([, participant]) => !participant.id.includes(GUEST_PREFIX))
    .map(([participantId, participant]) => ({ contact: participant, participantId }))
    .filter(({ participantId }) => getIsParticipantIsActive(room.pServedUser, fromPServedUser(participantId)))

  return subscribers.concat(guests)
}
